import PrimaryMenuItem from '../model/PrimaryMenuItem.js';
import SecondaryMenuItem from '../model/SecondaryMenuItem';
import TertiaryMenuItem from '../model/TertiaryMenuItem';

// 第一層
const customer = new PrimaryMenuItem('Customer', 'people_alt');
// 第二層
const memberManagement = new SecondaryMenuItem('MemberManagement');
const groupCustomer = new SecondaryMenuItem('GroupCustomer', () => import('@/modules/mbc/views/GroupCustomerList.vue'));
const pointBonusManagement = new SecondaryMenuItem('PointBonusManagement', () => import('@/modules/bns/views/PointBonusManagement.vue'));
const redeemManagement = new SecondaryMenuItem('RedeemManagement');
const BatchTagManagement = new SecondaryMenuItem('BatchTagManagement', () => import('@/modules/batchtag/views/BatchTagManagement.vue'));
const TagManagement = new SecondaryMenuItem('TagManagement', () => import('@/modules/tag/views/TagManagement.vue'));
// const MarketManagement = new SecondaryMenuItem('MarketManagement', () => import('@/modules/que/views/List.vue'));
// 註冊第二層
customer.RegisterChild(memberManagement);
customer.RegisterChild(groupCustomer);
customer.RegisterChild(pointBonusManagement);
customer.RegisterChild(redeemManagement);
customer.RegisterChild(BatchTagManagement);
customer.RegisterChild(TagManagement);
// 會員第三層
const memberList = new TertiaryMenuItem('MemberList', () => import('@/modules/mbc/views/MemberList.vue'));
const prospectiveCustomerList = new TertiaryMenuItem('ProspectiveCustomerList', () => import('@/modules/mbc/views/ProspectiveCustomerList.vue'));
// 註冊第三層
memberManagement.RegisterChild(memberList);
memberManagement.RegisterChild(prospectiveCustomerList);

// 兌禮第三層
const redeemItemManagement = new TertiaryMenuItem('RedeemItemManagement', () => import('@/modules/pdi/views/Redeem.vue'));
const redeemOrderManagement = new TertiaryMenuItem('RedeemOrderManagement', () => import('@/modules/pdi/views/RedeemOrder.vue'));
// 註冊第三層
redeemManagement.RegisterChild(redeemItemManagement);
redeemManagement.RegisterChild(redeemOrderManagement);

export default customer;
